import amapi from '@/api/amapi'

const initialState = () => ({
  ftpAccounts: [],
  port: null
})

const state = initialState

const getters = {
  ftpAccounts: state => state.ftpAccounts.map(account => ({ ...account })), // copy
  ftpSubAccounts: state => state.ftpAccounts.filter(account => account.type === 'sub'),
  ftpSpecialAccounts: state => state.ftpAccounts.filter(account => account.type !== 'sub'),
  ftpPort: state => state.port,
  ftpAccountByDomainAndUser: state => ({ domain, user }) => state.ftpAccounts.find(acc => acc.login === `${user}@${domain}`)
}

const mutations = {
  SET_FTP_ACCOUNTS: (state, accounts) => {
    state.ftpAccounts = accounts
  },
  SET_FTP_PORT: (state, port) => {
    state.port = port
  },
  CLEAR_FTP_STORE (state) {
    const s = initialState()

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

const actions = {
  async addFtpAccount ({ commit, dispatch }, { user, pass, homedir, quota = '0', domain, _username }) {
    try {
      const data = {
        uapi_module: 'Ftp',
        uapi_function: 'add_ftp',
        _username,
        user,
        pass,
        homedir,
        quota,
        domain
      }
      return amapi.cpanel_uapi(data)
    } catch (e) {
      throw e
    }
  },

  // autocomplete
  async autocompleteDir ({ commit, dispatch }, { path, dirsonly = '1', list_all = '0', html = '0', _username }) {
    try {
      const data = {
        uapi_module: 'Fileman',
        uapi_function: 'autocompletedir',
        _username,
        path,
        dirsonly,
        list_all,
        html
      }
      return amapi.cpanel_uapi(data)
    } catch (e) {
      throw e
    }
  },
  // get list of all ftp accounts with disk usage information
  async getFtpAccountsList ({ commit, dispatch }, _username) {
    try {
      const data = {
        uapi_module: 'Ftp',
        uapi_function: 'list_ftp_with_disk',
        _username,
      }

      const response = await amapi.cpanel_uapi(data)
      commit('SET_FTP_ACCOUNTS', response.data)
    } catch (e) {
      throw e
    }
  },
  // delete existing FTP account
  async deleteFtpAccount ({ commit, dispatch }, { domain, user, destroy = '0', _username }) {
    try {
      const data = {
        uapi_module: 'Ftp',
        uapi_function: 'delete_ftp',
        _username,
        domain,
        user,
        destroy
      }
      await amapi.cpanel_uapi(data)
    } catch (e) {
      throw e
    }
  },
  // update quota
  async setFtpAccountQuota ({ commit, dispatch }, { domain, user, quota, _username }) {
    try {
      const data = {
        uapi_module: 'Ftp',
        uapi_function: 'set_quota',
        _username,
        domain,
        user,
        quota
      }

      await amapi.cpanel_uapi(data)
    } catch (e) {
      throw e
    }
  },
  // update homedir
  async setFtpHomeDir ({ commit, dispatch }, { user, homedir, _username }) {
    try {
      const data = {
        uapi_module: 'Ftp',
        uapi_function: 'set_homedir',
        _username,
        user,
        homedir,
      }

      return amapi.cpanel_uapi(data)
    } catch (e) {
      throw e
    }
  },
  // change password for account
  async setFtpAccountPassword ({ commit, dispatch }, { domain, user, pass, _username }) {
    const data = {
      uapi_module: 'Ftp',
      uapi_function: 'passwd',
      _username,
      domain,
      user,
      pass
    }
    try {
      return await amapi.cpanel_uapi(data)
    } catch (e) {
      throw e
    }
  },
  // get FTP port
  async getFtpPort ({ commit, dispatch, state }, _username) {
    try {
      const data = {
        uapi_module: 'Ftp',
        uapi_function: 'get_port',
        _username,
      }
      if (state.port) {
        // use current value
        return Promise.resolve()
      } else {
        const response = await amapi.cpanel_uapi(data)
        commit('SET_FTP_PORT', response.data.port)
      }
    } catch (e) {
      throw e
    }
  },
  // get FTP port
  async ftpExists ({ dispatch }, { domain, user, _username }) {
    try {
      const data = {
        uapi_module: 'Ftp',
        uapi_function: 'ftp_exists',
        _username,
        domain,
        user
      }

      await amapi.cpanel_uapi(data)
    } catch (e) {
      throw e
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
